export default [
  {
    name: 'ObjectManager.AssignedList',
    path: 'list',
    component: () => import('./components/schedule/List'),
    meta: { wide: true }
  }
]
